import { selectHelplyAccountId } from 'ducks/accounts/selectors/selectHelplyAccountId'
import { selectPrefersAiEnabled } from 'selectors/app/selectAccountPreferences'

// Whether this Groove account has the Helply Copilot addon enabled — gates the
// copilot panel (any user in an entitled account may use it).
//
// TODO(groove-backend): back this with the real addon/entitlement. Until then,
// helply_account_id alone is enough.

export const selectHasHelplyCopilotAddon = state => {
  // Need to respect the account settings for AI Features being disabled
  if (!selectPrefersAiEnabled(state)) return false

  return !!selectHelplyAccountId(state)
}
